var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplainActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15747",
    "data-name": "Rectangle 15747",
    width: 14.732,
    height: 14.729,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40026",
    "data-name": "Group 40026",
    transform: "translate(-8 -318)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15748",
    "data-name": "Rectangle 15748",
    width: 18,
    height: 18,
    transform: "translate(8 318)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40027",
    "data-name": "Group 40027",
    transform: "translate(10 320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40026-2",
    "data-name": "Group 40026",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82657",
    "data-name": "Path 82657",
    d: "M14.666,1.122A1.584,1.584,0,0,0,13.158,0Q7.37,0,1.582,0A1.575,1.575,0,0,0,.007,1.586c0,2.8.009,5.6-.007,8.4a1.628,1.628,0,0,0,1.66,1.661c1.141,0,2.282,0,3.422,0a.233.233,0,0,1,.25.15c.35.718.716,1.428,1.065,2.146a1.383,1.383,0,0,0,.8.791h.345a1.394,1.394,0,0,0,.8-.8c.353-.726.722-1.445,1.079-2.169a.175.175,0,0,1,.185-.113q1.731,0,3.463,0a1.6,1.6,0,0,0,1.581-1.1c.03-.09.052-.182.078-.273V1.352c-.022-.077-.043-.154-.066-.23",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82658",
    "data-name": "Path 82658",
    d: "M228.507,72.906c0,.54,0,1.079,0,1.619a.827.827,0,1,1-1.652,0q-.007-1.643,0-3.286a.827.827,0,1,1,1.652,0c.005.556,0,1.112,0,1.667",
    transform: "translate(-220.314 -68.344)",
    fill: "#292961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82659",
    "data-name": "Path 82659",
    d: "M232.732,270.782a.7.7,0,1,1-.7-.7.695.695,0,0,1,.7.7",
    transform: "translate(-224.666 -262.297)",
    fill: "#292961"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplainActive);
export default __webpack_public_path__ + "static/media/complain-active.703334d99a548f6d8d45ef8788c65a73.svg";
export { ForwardRef as ReactComponent };